import React, { useState } from "react";
import PropTypes from "prop-types";
import { useSelector, useDispatch } from "react-redux";
import { Button } from "react-bootstrap";

import ModalGenericPostCancelContainer from "../../../Common/ModalGenericPostCancelContainer";
import TextareaModalContent from "../../../Common/IleggelseClient/TextareaModalContent";

import { getMiljogebyr as getMiljogebyrAction } from "../../../../actions/miljogebyrerActions";
import {
  getMiljogebyrEttersendelser as getMiljogebyrEttersendelserAction,
  postMiljogebyrEttersendelser as postMiljogebyrEttersendelserAction,
} from "../../../../actions/miljogebyrEttersendelserActions";

import { commentHasToBeBetween } from "../../../../constants/ErrorMessages";
import {
  ettersendelsesrapportMinLength,
  ettersendelsesrapportMaxLength,
} from "../../../../constants/globals";

export default function NyEttersendelseContainer({ reloadHistorikk }) {
  const miljogebyr = useSelector((state) => state.miljogebyr);
  const dispatch = useDispatch();

  const [kommentar, setKommentar] = useState(null);
  const [kommentarValidationError, setKommentarValidationError] =
    useState(null);

  const getMiljogebyr = (id) => dispatch(getMiljogebyrAction(id));
  const getMiljogebyrEttersendelser = (id) =>
    dispatch(getMiljogebyrEttersendelserAction(id));
  const postMiljogebyrEttersendelser = (id, params) =>
    dispatch(postMiljogebyrEttersendelserAction(id, params));

  const validation = () =>
    kommentar &&
    kommentar.length >= ettersendelsesrapportMinLength &&
    kommentar.length <= ettersendelsesrapportMaxLength;

  const handleApiCall = async (miljogebyrId) => {
    if (validation()) {
      return postMiljogebyrEttersendelser(miljogebyrId, {
        kommentar,
      })
        .then(() => {
          setKommentar(null);
          setKommentarValidationError(null);
          getMiljogebyr(miljogebyrId);
          getMiljogebyrEttersendelser(miljogebyrId);
          reloadHistorikk();
          return Promise.resolve();
        })
        .catch((error) => Promise.reject(error));
    } else {
      setKommentarValidationError(true);
      return Promise.reject("validationError");
    }
  };

  if (
    !miljogebyr.isTilEttersendelse &&
    !miljogebyr.isMakulert &&
    !miljogebyr.isBetalt
  ) {
    return (
      <ModalGenericPostCancelContainer
        id={miljogebyr.id}
        modalTitle={`Ny ettersendelse av miljogebyr ${miljogebyr.ileggelsesnummer}`}
        submitButtonText="Lag ny ettersendelse"
        submittingButtonText="Lager ny ettersendelse..."
        successPostCallFlashMessage="Endring fullført"
        errorPostCallFlashMessage="Endring feilet"
        handleApiCall={handleApiCall}
        openModalComponentFunction={(props) => (
          <Button
            className="btn btn-bym-standard"
            style={{ marginLeft: 20 }}
            onClick={props.openModal}
          >
            Ny Ettersendelse
          </Button>
        )}
      >
        <TextareaModalContent
          paragrapghText={`Ønsker du å lage en ny ettersendelse for ileggele ${miljogebyr.ileggelsesnummer}?`}
          kommentarValidationError={kommentarValidationError}
          textareaLabel="Ettersendelsesrapport"
          textareaPlaceholder="Ettersendelsesrapport"
          validationErrorText={commentHasToBeBetween(
            ettersendelsesrapportMinLength,
            ettersendelsesrapportMaxLength,
          )}
          handleChange={(e) => setKommentar(e.target.value)}
        />
      </ModalGenericPostCancelContainer>
    );
  }
  return <span />;
}

NyEttersendelseContainer.propTypes = {
  reloadHistorikk: PropTypes.func,
};
